export default "__VITE_ASSET__81073a78__"